import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from './baseQueryWithReauth';

export interface DownloadFileResponse {
  
    id: string;
    fileName: string;
    created: string;
    downloadUrl: string;
  }


export interface DownloadResponse {
  files: Array<DownloadFileResponse>;
    errors: any
  }


export const downloadsApi = createApi({
  reducerPath: 'downloadsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getUserDownloads: builder.query<DownloadResponse, void>({
      query: () => 'download/exports',
    }),
  }),
});

export const { useGetUserDownloadsQuery } = downloadsApi;
